import * as React from "react";
import { marketColumnsDisplay } from "../../../../../constants";
import { InstantCollapsible } from "sb-resp-ui";
import { ContainerQuery } from "react-container-query";
import { SecondaryHeadingContent } from "../../SecondaryHeadingContent";
import { SecondaryHeading } from "../../SecondaryHeading";
import { HeadingTitle } from "../../HeadingTitle";
import { RenderMarketNames } from "../../RenderComponents/RenderMarketNames";
export class MultiviewStyle extends SecondaryHeadingContent {
    /* istanbul ignore next */
    /* super transpiles to  var _this = _super.call(this) || this; */
    constructor(props) {
        super(props);
    }
    renderSubheading(params) {
        return React.createElement(SecondaryHeading, { key: `subheading-${this.props.id}`, componentPrefix: this.props.cardType },
            React.createElement(HeadingTitle, { name: this.props.name, eventsCount: this.props.eventsCount }),
            this.props.marketNames.length
                ? React.createElement(RenderMarketNames, { marketNames: this.props.marketNames, marketTemplates: this.props.marketTemplates, queryParams: params })
                : "");
    }
    render() {
        return (React.createElement(InstantCollapsible, { key: `collapse-subheading-${this.props.id}`, initiallyExpanded: this.props.shouldExpand, trigger: React.createElement(ContainerQuery, { query: marketColumnsDisplay }, (params) => this.renderSubheading(params)), content: React.createElement(React.Fragment, null, this.props.children) }));
    }
}
//# sourceMappingURL=MultiviewStyle.js.map